module.exports = __webpack_public_path__ + "img/naega_di_logo_ellipse.ff16d62a.svg";